module.exports = __webpack_public_path__ + "img/BOÉ_ROUND_S.6b0e3768.png";